import { AnyAction, combineReducers } from "@reduxjs/toolkit";
import combineTreatmentReducer from "../../pages/CombineTreatmentPage/reducer";
import configurationReducer from "../../pages/ConfigurationPage/reducer";
import dashboardReducer from "../../pages/DashboardPage/reducer";
import diseaseReducer from "../../pages/DiseasePage/reducer";
import loginReducer, { loginActions } from "../../pages/LoginPage/reducer";
import messageReducer from "../../pages/MessagePage/reducer";
import opDetailReducer from "../../pages/OperationDetailPage/reducer";
import overviewReducer from "../../pages/OverviewPage/reducer";
import planOperationReducer from "../../pages/PlanOperationPage/reducer";
import routeReducer from "../../pages/RoutePage/reducer";
import siteMonitoringReducer from "../../pages/SiteMonitoringPage/reducer";
import taskTypeReducer from "../../pages/TaskTypeManagementPage/reducer";
import userReducer from "../../pages/UserPage/reducer";
import vesselDetailReducer from "../../pages/VesselDetailPage/reducer";
import vesselManagementReducer from "../../pages/VesselManagementPage/reducer";
import weatherReducer from "../../pages/WeatherPage/reducer";
import { NAME_SLICE as checklist } from "./checklist/constants";
import checklistReducer from "./checklist/reducer";
import { NAME_SLICE as factory } from "./factory/constants";
import factoryReducer from "./factory/reducer";
import { NAME_SLICE as location } from "./location/constants";
import locationReducer from "./location/reducer";
import { NAME_SLICE as operation } from "./operation/constants";
import operationReducer from "./operation/reducer";
import { NAME_SLICE as region } from "./region/constants";
import regionReducer from "./region/reducer";
import { NAME_SLICE as site } from "./site/constants";
import siteReducer from "./site/reducer";
import { NAME_SLICE as vessel } from "./vessel/constants";
import vesselReducer from "./vessel/reducer";

const appReducer = combineReducers({
    login: loginReducer,
    dashboard: dashboardReducer,
    message: messageReducer,
    planOperation: planOperationReducer,
    overview: overviewReducer,
    operationDetail: opDetailReducer,
    disease: diseaseReducer,
    combineTreatment: combineTreatmentReducer,
    route: routeReducer,
    configuration: configurationReducer,
    siteMonitoring: siteMonitoringReducer,
    taskType: taskTypeReducer,
    vesselDetail: vesselDetailReducer,
    vesselManagement: vesselManagementReducer,
    user: userReducer,
    weather: weatherReducer,
    [location]: locationReducer,
    [region]: regionReducer,
    [factory]: factoryReducer,
    [site]: siteReducer,
    [checklist]: checklistReducer,
    [vessel]: vesselReducer,
    [operation]: operationReducer
});

const rootReducer = (state: any, action: AnyAction) => {
    if (action.type === loginActions.logout.type) {
        return appReducer({} as any, action);
    }
    return appReducer(state, action);
}
export default rootReducer;